var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcThumbDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Thumbs_x5F_Down",
    d: "M19,13.917h4v-12h-4 M15,1.917H6c-0.83,0-1.54,0.5-1.84,1.22l-3.02,7.05 C1.05,10.417,1,10.657,1,10.917v2c0,1.104,0.896,2,2,2h6.31l-0.95,4.569c-0.02,0.101-0.03,0.199-0.03,0.311 c0,0.42,0.17,0.79,0.44,1.061l1.06,1.061l6.58-6.59c0.369-0.36,0.59-0.86,0.59-1.41v-10C17,2.807,16.1,1.917,15,1.917z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcThumbDown);
export default __webpack_public_path__ + "static/media/ic_thumb_down.750f4348ff29c39c314a4b3148632ade.svg";
export { ForwardRef as ReactComponent };